<template>
  <PropertyDetailsCardRows v-if="hasInfo">
    <PropertyDetailsCardInfoItem
      v-for="item in accessibilityItems"
      :key="item.label"
      :label="item.label"
      :icon="item.icon"
      :value="item.value ? 'Yes' : 'No'"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.accessibility?.accessibilityNotes"
      label="Accessibility Notes"
      icon="align-left"
      :value="property?.accessibility?.accessibilityNotes"
    />
  </PropertyDetailsCardRows>

  <Text v-else variant="body-medium">Accessibility not specified</Text>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Text } from '@tallo/design-system';

import { accessibilityIconsMap, accessibilityMap } from '../../model/accessibility';
import { PropertyDto } from '../../model/property';
import PropertyDetailsCardInfoItem from './property-details-card/property-details-card-info-item.vue';
import PropertyDetailsCardRows from './property-details-card/property-details-card-rows.vue';

const props = defineProps<{
  property: PropertyDto | null | undefined;
}>();

const accessibilityItems = computed(() => {
  return Array.from(accessibilityMap)
    .filter(([key]) => props.property?.accessibility?.[key] !== null)
    .map(([fieldName, label]) => ({
      label,
      icon: accessibilityIconsMap[fieldName],
      value: props.property?.accessibility?.[fieldName],
    }));
});

const hasInfo = computed(() => {
  return props.property?.accessibility?.accessibilityNotes || Boolean(accessibilityItems.value.length);
});
</script>
